export class ValueUtils {
	static isSelected = (value) => {
		return !isEmpty(value) && value !== -1 && value !== '-1';
	};
	static isNotSelected = (value) => {
		return !ValueUtils.isSelected(value);
	};
}

